import { render, staticRenderFns } from "./CardMetric.vue?vue&type=template&id=3866c9ae&scoped=true&"
import script from "./CardMetric.vue?vue&type=script&lang=js&"
export * from "./CardMetric.vue?vue&type=script&lang=js&"
import style0 from "./CardMetric.vue?vue&type=style&index=0&id=3866c9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3866c9ae",
  null
  
)

export default component.exports